import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SessionStore } from './session.store';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/auth/o/token/')) {
    return next(req);
  }

  const session = inject(SessionStore).snapshot();

  if (!session) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `${session.tokenType} ${session.accessToken}`,
        'X-Tenant-Schema': session.schema,
      },
    }),
  );
};
